import defaultAttributes from '../defaultAttributes';

const Superscript = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'M4 19l8-8' }],
    ['path', { d: 'M12 19l-8-8' }],
    [
      'path',
      {
        d:
          'M20 12h-4c0-1.5.442-2 1.5-2.5S20 8.334 20 7.002c0-.472-.17-.93-.484-1.29a2.105 2.105 0 00-2.617-.436c-.42.239-.738.614-.899 1.06',
      },
    ],
  ],
];

export default Superscript;
